import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Paper, Button, Box } from '@material-ui/core';
import { Link } from 'react-router-dom';
import AppsIcon from '@material-ui/icons/Apps';
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';
import StarsIcon from '@material-ui/icons/Stars';
import { orange, amber } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
	root: {
		padding: 0,
		overflow: 'hidden',
		borderRadius: '12px',
		boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
		display: 'flex',
		flexDirection: 'column',
		flex: 1
	},
	heroicGameDaySection: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		textAlign: 'center',
		padding: theme.spacing(8, 4),
		background: 'linear-gradient(135deg, #667eea 0%, #7c6fd4 100%)',
		color: 'white',
		position: 'relative',
		flex: 1,
		[theme.breakpoints.down('sm')]: {
			padding: theme.spacing(6, 2)
		}
	},
	twoColumnContainer: {
		display: 'grid',
		gridTemplateColumns: 'repeat(3, 1fr)',
		gridTemplateRows: 'auto auto',
		gap: theme.spacing(3),
		width: '100%',
		maxWidth: 1200,
		[theme.breakpoints.down('md')]: {
			display: 'flex',
			flexDirection: 'column',
			gap: theme.spacing(4)
		}
	},
	leftPanel: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: theme.spacing(0.5),
		[theme.breakpoints.down('md')]: {
			flex: '1',
			width: '100%',
			order: 2,
			gap: theme.spacing(1)
		}
	},
	leftPanelTop: {
		gridColumn: 1,
		gridRow: 1,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'flex-end'
	},
	leftPanelBottom: {
		gridColumn: 1,
		gridRow: 2,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	logoCard: {
		borderRadius: '12px',
		padding: 0,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
		minWidth: '220px',
		minHeight: '220px',
		marginBottom: '-30px',
		[theme.breakpoints.down('md')]: {
			minWidth: 'auto',
			minHeight: 'auto',
			padding: 0
		}
	},
	heroLogo: {
		width: '100%',
		maxWidth: '220px',
		height: 'auto',
		[theme.breakpoints.down('sm')]: {
			maxWidth: '140px'
		}
	},
	verticalDivider: {
		height: '400px',
		backgroundColor: 'rgba(255,255,255,0.3)',
		width: '2px',
		[theme.breakpoints.down('md')]: {
			display: 'none'
		}
	},
	heroicLeftColumn: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: theme.spacing(1),
		[theme.breakpoints.down('md')]: {
			flex: '1',
			width: '100%',
			order: 1
		}
	},
	heroicLeftColumnTop: {
		gridColumn: 2,
		gridRow: 1,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'flex-end',
		gap: theme.spacing(1)
	},
	heroicLeftColumnBottom: {
		gridColumn: 2,
		gridRow: 2,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	heroicRightColumn: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: theme.spacing(2),
		maxWidth: '300px',
		[theme.breakpoints.down('md')]: {
			flex: '1',
			width: '100%',
			order: 3,
			maxWidth: 'none'
		}
	},
	heroicRightColumnTop: {
		gridColumn: 3,
		gridRow: 1,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'flex-end'
	},
	heroicRightColumnBottom: {
		gridColumn: 3,
		gridRow: 2,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		[theme.breakpoints.down('md')]: {
			maxWidth: '100%'
		}
	},
	heroicGameDayLogo: {
		width: '100%',
		maxWidth: '160px',
		height: 'auto',
		filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.2))',
		[theme.breakpoints.down('sm')]: {
			maxWidth: '140px'
		}
	},
	iconContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		gap: theme.spacing(2)
	},
	heroIcon: {
		fontSize: 80,
		color: amber[300],
		filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.2))',
		animation: '$bounce 2s ease-in-out infinite'
	},
	starsIcon: {
		fontSize: 50,
		color: amber[200],
		opacity: 0.8,
		filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))'
	},
	heroTitle: {
		fontSize: '3.5rem',
		fontWeight: 700,
		textShadow: '3px 3px 8px rgba(0,0,0,0.4)',
		marginBottom: theme.spacing(2),
		[theme.breakpoints.down('sm')]: {
			fontSize: '2.5rem'
		}
	},
	heroSubtitle: {
		fontSize: '1.75rem',
		fontWeight: 500,
		maxWidth: 700,
		margin: 0,
		opacity: 0.95,
		textAlign: 'center',
		width: '100%',
		textShadow: '2px 2px 6px rgba(0,0,0,0.35)',
		[theme.breakpoints.down('sm')]: {
			fontSize: '1.4rem'
		}
	},
	heroicButton: {
		backgroundColor: 'white',
		color: '#7c6fd4',
		padding: theme.spacing(2, 8),
		fontSize: '1.5rem',
		fontWeight: 700,
		borderRadius: '50px',
		textTransform: 'none',
		boxShadow: '0 6px 24px rgba(0,0,0,0.2)',
		transition: 'all 0.3s ease',
		'&:hover': {
			backgroundColor: '#f3f0ff',
			transform: 'translateY(-4px) scale(1.05)',
			boxShadow: '0 12px 32px rgba(0,0,0,0.3)'
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '1.3rem',
			padding: theme.spacing(1.5, 6)
		}
	},
	exploreButton: {
		padding: theme.spacing(1.5, 5),
		fontSize: '1.5rem',
		fontWeight: 600,
		color: 'white',
		borderColor: 'white',
		borderRadius: '50px',
		textTransform: 'none',
		textShadow: '1px 1px 3px rgba(0,0,0,0.3)',
		transition: 'all 0.3s ease',
		'&:hover': {
			backgroundColor: 'rgba(255,255,255,0.1)',
			borderColor: 'white'
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '1.2rem',
			padding: theme.spacing(1.5, 4)
		}
	},
	'@keyframes bounce': {
		'0%, 100%': {
			transform: 'translateY(0) rotate(-5deg)'
		},
		'50%': {
			transform: 'translateY(-10px) rotate(5deg)'
		}
	}
}));

function AppShowcase({ config = {}, branding = {} }) {
	const classes = useStyles();

	const {
		title = 'Welcome to Heidi',
		subtitle = 'Explore our applications and start your journey',
		heroicGameDayUrl = 'https://signup.americau.com/'
	} = config;

	const { welcomeMessage, accentColor } = branding;

	const handleHeroicGameDayClick = () => {
		window.open(heroicGameDayUrl, '_blank');
	};

	return (
		<Paper className={classes.root} elevation={0}>
			{/* Heroic Game Day Hero Section */}
			<div className={classes.heroicGameDaySection}>
				{/* Two-Column Container */}
				<Box className={classes.twoColumnContainer}>
					{/* Left Panel - Heidi Branding - Top Cell */}
					<Box className={classes.leftPanelTop}>
						{/* White Rounded Card with Logo */}
						<Box className={classes.logoCard}>
							<img src="assets/images/logos/heidi_white_simple_logo.png" alt="Heidi Logo" className={classes.heroLogo} />
						</Box>
					</Box>

					{/* Left Panel - Explore Button - Bottom Cell */}
					<Box className={classes.leftPanelBottom}>
						<Button
							variant="outlined"
							size="large"
							className={classes.exploreButton}
							component={Link}
							to="/heidi-apps"
							startIcon={<AppsIcon />}
						>
							Explore All Applications
						</Button>
					</Box>

					{/* Middle Column - Icons, Title - Top Cell */}
					<Box className={classes.heroicLeftColumnTop}>
						<Box className={classes.iconContainer}>
							<StarsIcon className={classes.starsIcon} />
							<EmojiEventsIcon className={classes.heroIcon} />
							<StarsIcon className={classes.starsIcon} />
						</Box>

						<Typography className={classes.heroTitle}>Heroic Game Day!</Typography>
					</Box>

					{/* Middle Column - Start Playing Button - Bottom Cell */}
					<Box className={classes.heroicLeftColumnBottom}>
						<Button className={classes.heroicButton} onClick={handleHeroicGameDayClick} size="large">
							Start Playing Now!{' '}
							<span style={{ fontSize: '1.8rem', marginLeft: '8px' }}>🎮</span>
						</Button>
					</Box>

					{/* Right Column - Logo - Top Cell */}
					<Box className={classes.heroicRightColumnTop}>
						<img
							src="assets/images/logos/heroic.png"
							alt="Heroic Game Day"
							className={classes.heroicGameDayLogo}
						/>
					</Box>

					{/* Right Column - Subtitle - Middle Cell */}
					<Box className={classes.heroicRightColumnBottom}>
						<Typography className={classes.heroSubtitle}>
							Join the adventure and play exciting educational games. Earn points, unlock achievements,
							and become a hero!
						</Typography>
					</Box>
				</Box>
			</div>
		</Paper>
	);
}

export default AppShowcase;
